import React, { useEffect, useState } from "react";
import { t } from "i18next";

function VehicleSpecsCard({ fileUrl, name }) {
  return (
    <div className="w-full flex flex-col items-center">
      {fileUrl && (
        <img className="h-[32px] w-[45px] mb-2" src={fileUrl} alt={name} />
      )}
      <span
        className="font-light text-black text-center"
        style={{
          fontSize: isSmallScreen ? "10px" : "14px",
          fontFamily: "MBCorpoSText-Regular-Web-new",
        }}
      >
        {name}
      </span>
    </div>
  );
}
const isSmallScreen = window.innerWidth <= 768;
const isDesktopScreen = window.innerWidth >= 1310;
function VehicleParameters({ specifications }) {
  const [vehicleParameters, setVehicleParameters] = useState([]);

  useEffect(() => {
    if (specifications && Array.isArray(specifications)) {
      const sortedParameters = [...specifications].sort((a, b) => {
        if (a.position !== b.position) {
          return a.position - b.position;
        }
        return a.name.localeCompare(b.name);
      });

      setVehicleParameters(sortedParameters);
    }
  }, [specifications]);

  return (
    <>
      {!isSmallScreen && (
        <div>
          <h2
            style={{
              fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
              color: "#1E1E1E",
              fontSize: "32px",
            }}
          >
            {t("Vehicle Details")}
          </h2>
        </div>
      )}
      {!isSmallScreen && (
        <hr
          style={{
            border: "none",
            borderTop: "1px solid #000000",
            marginTop: "17px",
            marginRight: isDesktopScreen ? "2%" : "undefined",
          }}
        />
      )}
      <div
        className="grid grid-cols-6 md:grid-cols-6 gap-10 px-4"
        style={
          !isSmallScreen
            ? { marginTop: "30px", width: "100%" }
            : { marginTop: "10px", marginLeft: "" }
        }
      >
        {vehicleParameters?.map((el, index) => {
          const colonIndex = el?.name.indexOf(":") + 1;
          const displayName =
            colonIndex !== -1 ? el?.name.slice(colonIndex) : el?.name;
          return (
            <div key={index} className="h-fit w-full text-sm gap-6">
              {el && (
                <VehicleSpecsCard
                  fileUrl={el.fileUrl}
                  name={isSmallScreen ? displayName : el?.name}
                />
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}

export { VehicleParameters };
